import { render, staticRenderFns } from "./checkMobile.vue?vue&type=template&id=74b96ace"
import script from "./checkMobile.vue?vue&type=script&lang=js"
export * from "./checkMobile.vue?vue&type=script&lang=js"
import style0 from "./checkMobile.vue?vue&type=style&index=0&id=74b96ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports